export const initialFilters = {
	language: "all",
	sort: "newest",
};
